export const userConstants = {

    UPDATE_USER_REQUEST: 'UPDATE_USER_REQUEST',
    UPDATE_USER_SUCCESS: 'UPDATE_USER_SUCCESS',
    UPDATE_USER_FAILURE: 'UPDATE_USER_FAILURE',

    GET_ALL_USER_REQUEST: 'GET_ALL_USER_REQUEST',
    GET_ALL_USER_SUCCESS: 'GET_ALL_USER_SUCCESS',
    GET_ALL_USER_FAILURE: 'GET_ALL_USER_FAILURE',

    GET_USER_LIST_REQUEST: 'GET_USER_LIST_REQUEST',
    GET_USER_LIST_SUCCESS: 'GET_USER_LIST_SUCCESS',
    GET_USER_LIST_FAILURE: 'GET_USER_LIST_FAILURE',

    GET_LEAD_LIST_REQUEST: 'GET_LEAD_LIST_REQUEST',
    GET_LEAD_LIST_SUCCESS: 'GET_LEAD_LIST_SUCCESS',
    GET_LEAD_LIST_FAILURE: 'GET_LEAD_LIST_FAILURE',

    GET_REMAINDER_LIST_REQUEST: 'GET_REMAINDER_LIST_REQUEST',
    GET_REMAINDER_LIST_SUCCESS: 'GET_REMAINDER_LIST_SUCCESS',
    GET_REMAINDER_LIST_FAILURE: 'GET_REMAINDER_LIST_FAILURE',

    DELETE_TICKET_REQUEST: 'DELETE_TICKET_REQUEST',
    DELETE_TICKET_SUCCESS: 'DELETE_TICKET_SUCCESS',
    DELETE_TICKET_FAILURE: 'DELETE_TICKET_FAILURE',

    DISABLE_TICKET_REQUEST: 'DISABLE_TICKET_REQUEST',
    DISABLE_TICKET_SUCCESS: 'DISABLE_TICKET_SUCCESS',
    DISABLE_TICKET_FAILURE: 'DISABLE_TICKET_FAILURE',

    APPROVE_TICKET_REQUEST: 'APPROVE_TICKET_REQUEST',
    APPROVE_TICKET_SUCCESS: 'APPROVE_TICKET_SUCCESS',
    APPROVE_TICKET_FAILURE: 'APPROVE_TICKET_FAILURE',

    UPDATE_LEAD_REQUEST: 'UPDATE_LEAD_REQUEST',
    UPDATE_LEAD_SUCCESS: 'UPDATE_LEAD_SUCCESS',
    UPDATE_LEAD_FAILURE: 'UPDATE_LEAD_FAILURE',

    UPDATE_FOLLOW_UP_REQUEST: 'UPDATE_FOLLOW_UP_REQUEST',
    UPDATE_FOLLOW_UP_SUCCESS: 'UPDATE_FOLLOW_UP_SUCCESS',
    UPDATE_FOLLOW_UP_FAILURE: 'UPDATE_FOLLOW_UP_FAILURE',




    USERS_LOGIN_REQUEST: 'USERS_LOGIN_REQUEST',
    USERS_LOGIN_SUCCESS: 'USERS_LOGIN_SUCCESS',
    USERS_LOGIN_FAILURE: 'USERS_LOGIN_FAILURE',

    LOGIN_TO_THIS_ACCOUNT_REQUEST: 'USERS_LOGIN_TO_THIS_ACCOUNT_REQUEST',
    LOGIN_TO_THIS_ACCOUNT_SUCCESS: 'USERS_LOGIN_TO_THIS_ACCOUNT_SUCCESS',
    LOGIN_TO_THIS_ACCOUNT_FAILURE: 'USERS_LOGIN_TO_THIS_ACCOUNT_FAILURE',

    GET_EMS_SLOT_BOOKING_REQUEST: 'USERS_GET_EMS_SLOT_BOOKING_REQUEST',
    GET_EMS_SLOT_BOOKING_SUCCESS: 'USERS_GET_EMS_SLOT_BOOKING_SUCCESS',
    GET_EMS_SLOT_BOOKING_FAILURE: 'USERS_GET_EMS_SLOT_BOOKING_FAILURE',

    GET_LEAD_BY_ID_REQUEST: 'GET_LEAD_BY_ID_REQUEST',
    GET_LEAD_BY_ID_SUCCESS: 'GET_LEAD_BY_ID_SUCCESS',
    GET_LEAD_BY_ID_FAILURE: 'GET_LEAD_BY_ID_FAILURE',

    GET_TX_LIST_BY_USER_REQUEST: 'GET_TX_LIST_BY_USER_REQUEST',
    GET_TX_LIST_BY_USER_SUCCESS: 'GET_TX_LIST_BY_USER_SUCCESS',
    GET_TX_LIST_BY_USER_FAILURE: 'GET_TX_LIST_BY_USER_FAILURE',

    GET_FOLLOW_UP_LIST_BY_LEAD_ID_REQUEST: 'GET_FOLLOW_UP_LIST_BY_LEAD_ID_REQUEST',
    GET_FOLLOW_UP_LIST_BY_LEAD_ID_SUCCESS: 'GET_FOLLOW_UP_LIST_BY_LEAD_ID_SUCCESS',
    GET_FOLLOW_UP_LIST_BY_LEAD_ID_FAILURE: 'GET_FOLLOW_UP_LIST_BY_LEAD_ID_FAILURE',

    GET_LOGIN_HISTORY_REQUEST: 'GET_LOGIN_HISTORY_REQUEST',
    GET_LOGIN_HISTORY_SUCCESS: 'GET_LOGIN_HISTORY_SUCCESS',
    GET_LOGIN_HISTORY_FAILURE: 'GET_LOGIN_HISTORY_FAILURE',

    GET_GROUP_SLOT_BOOKING_REQUEST: 'USERS_GET_GROUP_SLOT_BOOKING_REQUEST',
    GET_GROUP_SLOT_BOOKING_SUCCESS: 'USERS_GET_GROUP_SLOT_BOOKING_SUCCESS',
    GET_GROUP_SLOT_BOOKING_FAILURE: 'USERS_GET_GROUP_SLOT_BOOKING_FAILURE',

    GET_TRAINER_SLOT_BOOKING_REQUEST: 'USERS_GET_TRAINER_SLOT_BOOKING_REQUEST',
    GET_TRAINER_SLOT_BOOKING_SUCCESS: 'USERS_GET_TRAINER_SLOT_BOOKING_SUCCESS',
    GET_TRAINER_SLOT_BOOKING_FAILURE: 'USERS_GET_TRAINER_SLOT_BOOKING_FAILURE',

    GET_MASSAGE_SLOT_BOOKING_REQUEST: 'USERS_GET_MASSAGE_SLOT_BOOKING_REQUEST',
    GET_MASSAGE_SLOT_BOOKING_SUCCESS: 'USERS_GET_MASSAGE_SLOT_BOOKING_SUCCESS',
    GET_MASSAGE_SLOT_BOOKING_FAILURE: 'USERS_GET_MASSAGE_SLOT_BOOKING_FAILURE',

    GET_PROFILE_REQUEST: 'USERS_GET_PROFILE_REQUEST',
    GET_PROFILE_SUCCESS: 'USERS_GET_PROFILE_SUCCESS',
    GET_PROFILE_FAILURE: 'USERS_GET_PROFILE_FAILURE',

    GET_DEACTIVE_USER_REQUEST: 'GET_DEACTIVE_USER_REQUEST',
    GET_DEACTIVE_USER_SUCCESS: 'GET_DEACTIVE_USER_SUCCESS',
    GET_DEACTIVE_USER_FAILURE: 'GET_DEACTIVE_USER_FAILURE',

    LOGOUT: 'USERS_LOGOUT',


    FILE_UPLOAD_STATUS_VIDEO_REQUEST: 'FILE_UPLOAD_STATUS_VIDEO_REQUEST',
    FILE_UPLOAD_STATUS_VIDEO_SUCCESS: 'FILE_UPLOAD_STATUS_VIDEO_SUCCESS',
    FILE_UPLOAD_STATUS_VIDEO_FAILURE: 'FILE_UPLOAD_STATUS_VIDEO_FAILURE',

    FILE_UPLOAD_STATUS_REQUEST: 'FILE_UPLOAD_STATUS_REQUEST',
    FILE_UPLOAD_STATUS_SUCCESS: 'FILE_UPLOAD_STATUS_SUCCESS',
    FILE_UPLOAD_STATUS_FAILURE: 'FILE_UPLOAD_STATUS_FAILURE',


    GETALL_USER_ACTIVE_REQUEST: 'GETALL_USER_ACTIVE_REQUEST',
    GETALL_USER_ACTIVE_SUCCESS: 'GETALL_USER_ACTIVE_SUCCESS',
    GETALL_USER_ACTIVE_FAILURE: 'GETALL_USER_ACTIVE_FAILURE',

    GETALL_USER_DEACTIVE_REQUEST: 'GETALL_USER_DEACTIVE_REQUEST',
    GETALL_USER_DEACTIVE_SUCCESS: 'GETALL_USER_DEACTIVE_SUCCESS',
    GETALL_USER_DEACTIVE_FAILURE: 'GETALL_USER_DEACTIVE_FAILURE',

    DISABLE_LEAD_REQUEST: 'DISABLE_LEAD_REQUEST',
    DISABLE_LEAD_SUCCESS: 'DISABLE_LEAD_SUCCESS',
    DISABLE_LEAD_FAILURE: 'DISABLE_LEAD_FAILURE',

    DISABLE_REMINDER_REQUEST: 'DISABLE_REMINDER_REQUEST',
    DISABLE_REMINDER_SUCCESS: 'DISABLE_REMINDER_SUCCESS',
    DISABLE_REMINDER_FAILURE: 'DISABLE_REMINDER_FAILURE',

    DELETE_LEAD_REQUEST: 'DELETE_LEAD_REQUEST',
    DELETE_LEAD_SUCCESS: 'DELETE_LEAD_SUCCESS',
    DELETE_LEAD_FAILURE: 'DELETE_LEAD_FAILURE',

    DELETE_CATEGORY_REQUEST: 'DELETE_CATEGORY_REQUEST',
    DELETE_CATEGORY_SUCCESS: 'DELETE_CATEGORY_SUCCESS',
    DELETE_CATEGORY_FAILURE: 'DELETE_CATEGORY_FAILURE',

    USER_VERIFY_EMAIL_REQUEST: 'USER_VERIFY_EMAIL_REQUEST',
    USER_VERIFY_EMAIL_SUCCESS: 'USER_VERIFY_EMAIL_SUCCESS',
    USER_VERIFY_EMAIL_FAILURE: 'USER_VERIFY_EMAIL_FAILURE',

    UPDATE_USER_PASSWORD_REQUEST: 'UPDATE_USER_PASSWORD_REQUEST',
    UPDATE_USER_PASSWORD_SUCCESS: 'UPDATE_USER_PASSWORD_SUCCESS',
    UPDATE_USER_PASSWORD_FAILURE: 'UPDATE_USER_PASSWORD_FAILURE',

    ADD_LEAD_REQUEST: 'ADD_LEAD_REQUEST',
    ADD_LEAD_SUCCESS: 'ADD_LEAD_SUCCESS',
    ADD_LEAD_FAILURE: 'ADD_LEAD_FAILURE',

    CREATE_USER_REQUEST: 'CREATE_USER_REQUEST',
    CREATE_USER_SUCCESS: 'CREATE_USER_SUCCESS',
    CREATE_USER_FAILURE: 'CREATE_USER_FAILURE',

    GETALL_SERIES_REQUEST: 'GETALL_SERIES_REQUEST',
    GETALL_SERIES_SUCCESS: 'GETALL_SERIES_SUCCESS',
    GETALL_SERIES_FAILURE: 'GETALL_SERIES_FAILURE',

    GET_ODDS_REQUEST: 'GET_ODDS_REQUEST',
    GET_ODDS_SUCCESS: 'GET_ODDS_SUCCESS',
    GET_ODDS_FAILURE: 'GET_ODDS_FAILURE',

    GET_MATCH_BY_MATCHID_REQUEST: 'GET_MATCH_BY_MATCHID_REQUEST',
    GET_MATCH_BY_MATCHID_SUCCESS: 'GET_MATCH_BY_MATCHID_SUCCESS',
    GET_MATCH_BY_MATCHID_FAILURE: 'GET_MATCH_BY_MATCHID_FAILURE',

    GETALL_SPORT_REQUEST: 'GETALL_SPORT_REQUEST',
    GETALL_SPORT_SUCCESS: 'GETALL_SPORT_SUCCESS',
    GETALL_SPORT_FAILURE: 'GETALL_SPORT_FAILURE',

    GETALL_MATCH_REQUEST: 'GETALL_MATCH_REQUEST',
    GETALL_MATCH_SUCCESS: 'GETALL_MATCH_SUCCESS',
    GETALL_MATCH_FAILURE: 'GETALL_MATCH_FAILURE',

    GETALL_MATCH_ACTIVE_REQUEST: 'GETALL_MATCH_ACTIVE_REQUEST',
    GETALL_MATCH_ACTIVE_SUCCESS: 'GETALL_MATCH_ACTIVE_SUCCESS',
    GETALL_MATCH_ACTIVE_FAILURE: 'GETALL_MATCH_ACTIVE_FAILURE',

    GETALL_PROFILE_REQUEST: 'GETALL_PROFILE_REQUEST',
    GETALL_PROFILE_SUCCESS: 'GETALL_PROFILE_SUCCESS',
    GETALL_PROFILE_FAILURE: 'GETALL_PROFILE_FAILURE',

    UPDATE_MATCH_TEAM_IMAGE_REQUEST: 'UPDATE_MATCH_TEAM_IMAGE_REQUEST',
    UPDATE_MATCH_TEAM_IMAGE_SUCCESS: 'UPDATE_MATCH_TEAM_IMAGE_SUCCESS',
    UPDATE_MATCH_TEAM_IMAGE_FAILURE: 'UPDATE_MATCH_TEAM_IMAGE_FAILURE',

    ADD_SPORT_REQUEST: 'ADD_SPORT_REQUEST',
    ADD_SPORT_SUCCESS: 'ADD_SPORT_SUCCESS',
    ADD_SPORT_FAILURE: 'ADD_SPORT_FAILURE',

    ADD_SERIES_REQUEST: 'ADD_SERIES_REQUEST',
    ADD_SERIES_SUCCESS: 'ADD_SERIES_SUCCESS',
    ADD_SERIES_FAILURE: 'ADD_SERIES_FAILURE',

    CREATE_BALANCE_REQUEST: 'CREATE_BALANCE_REQUEST',
    CREATE_BALANCE_SUCCESS: 'CREATE_BALANCE_SUCCESS',
    CREATE_BALANCE_FAILURE: 'CREATE_BALANCE_FAILURE',

    DEDUCT_BALANCE_REQUEST: 'DEDUCT_BALANCE_REQUEST',
    DEDUCT_BALANCE_SUCCESS: 'DEDUCT_BALANCE_SUCCESS',
    DEDUCT_BALANCE_FAILURE: 'DEDUCT_BALANCE_FAILURE',

    ADD_MATCH_REQUEST: 'ADD_MATCH_REQUEST',
    ADD_MATCH_SUCCESS: 'ADD_MATCH_SUCCESS',
    ADD_MATCH_FAILURE: 'ADD_MATCH_FAILURE',

    UPDATE_MATCH_MARKET_ID_REQUEST: 'UPDATE_MATCH_MARKET_ID_REQUEST',
    UPDATE_MATCH_MARKET_ID_SUCCESS: 'UPDATE_MATCH_MARKET_ID_SUCCESS',
    UPDATE_MATCH_MARKET_ID_FAILURE: 'UPDATE_MATCH_MARKET_ID_FAILURE',


    UPDATE_USERS_PASSWORD_REQUEST: 'UPDATE_USER_PASSWORD_REQUEST',
    UPDATE_USERS_PASSWORD_SUCCESS: 'UPDATE_USER_PASSWORD_SUCCESS',
    UPDATE_USERS_PASSWORD_FAILURE: 'UPDATE_USER_PASSWORD_FAILURE',


    UPDATE_MATCH_STATUS_REQUEST: 'UPDATE_MATCH_STATUS_REQUEST',
    UPDATE_MATCH_STATUS_SUCCESS: 'UPDATE_MATCH_STATUS_SUCCESS',
    UPDATE_MATCH_STATUS_FAILURE: 'UPDATE_MATCH_STATUS_FAILURE',


    FILE_UPLOAD_CLEAR_SUCCESS: 'FILE_UPLOAD_CLEAR_SUCCESS',


    ADD_CATEGORY_REQUEST: 'ADD_CATEGORY_REQUEST',
    ADD_CATEGORY_SUCCESS: 'ADD_CATEGORY_SUCCESS',
    ADD_CATEGORY_FAILURE: 'ADD_CATEGORY_FAILURE',

    UPDATE_CATEGORY_REQUEST: 'UPDATE_CATEGORY_REQUEST',
    UPDATE_CATEGORY_SUCCESS: 'UPDATE_CATEGORY_SUCCESS',
    UPDATE_CATEGORY_FAILURE: 'UPDATE_CATEGORY_FAILURE',

    GET_CATEGORY_LIST_REQUEST: 'GET_CATEGORY_LIST_REQUEST',
    GET_CATEGORY_LIST_SUCCESS: 'GET_CATEGORY_LIST_SUCCESS',
    GET_CATEGORY_LIST_FAILURE: 'GET_CATEGORY_LIST_FAILURE',

    UPDATE_CATEGORY_STATUS_REQUEST: 'UPDATE_CATEGORY_STATUS_REQUEST',
    UPDATE_CATEGORY_STATUS_SUCCESS: 'UPDATE_CATEGORY_STATUS_SUCCESS',
    UPDATE_CATEGORY_STATUS_FAILURE: 'UPDATE_CATEGORY_STATUS_FAILURE',

    GET_ALL_CATEGORY_REQUEST: 'GET_ALL_CATEGORY_REQUEST',
    GET_ALL_CATEGORY_SUCCESS: 'GET_ALL_CATEGORY_SUCCESS',
    GET_ALL_CATEGORY_FAILURE: 'GET_ALL_CATEGORY_FAILURE',

    // GETALL_USER_NOTIFY_REQUEST: 'GETALL_USER_NOTIFY_REQUEST',
    // GETALL_USER_NOTIFY_SUCCESS: 'GETALL_USER_NOTIFY_SUCCESS',
    // GETALL_USER_NOTIFY_FAILURE: 'GETALL_USER_NOTIFY_FAILURE',


    // ADD_RESTAURANT_USER_REQUEST: 'ADD_RESTAURANT_USER_REQUEST',
    // ADD_RESTAURANT_USER_SUCCESS: 'ADD_RESTAURANT_USER_SUCCESS',
    // ADD_RESTAURANT_USER_FAILURE: 'ADD_RESTAURANT_USER_FAILURE',

    // FILE_UPLOAD_STATUS_REQUEST: 'FILE_UPLOAD_STATUS_REQUEST',
    // FILE_UPLOAD_STATUS_SUCCESS: 'FILE_UPLOAD_STATUS_SUCCESS',
    // FILE_UPLOAD_STATUS_FAILURE: 'FILE_UPLOAD_STATUS_FAILURE',


    // GET_RESTAURANT_REQUEST: 'GET_RESTAURANT_REQUEST',
    // GET_RESTAURANT_SUCCESS: 'GET_RESTAURANT_SUCCESS',
    // GET_RESTAURANT_FAILURE: 'GET_RESTAURANT_FAILURE',

    // ADD_MENU_REQUEST: 'ADD_MENU_REQUEST',
    // ADD_MENU_SUCCESS: 'ADD_MENU_SUCCESS',
    // ADD_MENU_FAILURE: 'ADD_MENU_FAILURE',


    // ADD_ITEM_REQUEST: 'ADD_ITEM_REQUEST',
    // ADD_ITEM_SUCCESS: 'ADD_ITEM_SUCCESS',
    // ADD_ITEM_FAILURE: 'ADD_ITEM_FAILURE',

    // DEL_ITEM_REQUEST: 'DEL_ITEM_REQUEST',
    // DEL_ITEM_SUCCESS: 'DEL_ITEM_SUCCESS',
    // DEL_ITEM_FAILURE: 'DEL_ITEM_FAILURE',

    // UPDATE_CATEGORY_REQUEST: 'UPDATE_CATEGORY_REQUEST',
    // UPDATE_CATEGORY_SUCCESS: 'UPDATE_CATEGORY_SUCCESS',
    // UPDATE_CATEGORY_FAILURE: 'UPDATE_CATEGORY_FAILURE',

    // UPDATE_ITEM_REQUEST: 'UPDATE_ITEM_REQUEST',
    // UPDATE_ITEM_SUCCESS: 'UPDATE_ITEM_SUCCESS',
    // UPDATE_ITEM_FAILURE: 'UPDATE_ITEM_FAILURE',


    // STATS_REQUEST: 'STATS_REQUEST',
    // STATS_SUCCESS: 'STATS_SUCCESS',
    // STATS_FAILURE: 'STATS_FAILURE',

};
